module.exports = __webpack_public_path__ + "img/icon-order-active.7a05256f.svg";